const SearchIcon = () => {
    return <i className="fa-regular fa-magnifying-glass"></i>
}

export default SearchIcon;